import { useState } from 'react';
import { css } from "@emotion/react";
import DotLoader from "react-spinners/DotLoader";
import styles from './Loading.module.css';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: #1f6811;
`;

const Loading = () => {

let [color, setColor] = useState("#1f6811");

{/* https://www.davidhu.io/react-spinners/ */}
return (
    <div className= {`${styles.loading}`}>
      <div className={styles.centrado}>
        <DotLoader color={color} loading={true} css={override} size={200} />
      </div>
    </div>
)
}

export default Loading;